
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/alu/windows",
      function () {
        return require("private-next-pages/alu/windows/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/alu/windows"])
      });
    }
  